import { render, staticRenderFns } from "./Services.html?vue&type=template&id=79866852&external"
import script from "./Services.js?vue&type=script&lang=js&external"
export * from "./Services.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports